import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Form, Modal } from 'react-bootstrap'

import Header from 'components/ui/header'
import SquareReward from 'components/square_reward'
import CheckboxWithText from 'components/ui/checkbox_custom'
import Loading from 'components/ui/loading'

import Colors from 'utils/colors'
import { LuSend } from 'react-icons/lu'
import { Mail, MailDulceria, MailTaquilla, postResult } from 'services/result'
import { getGenerate } from 'services/activity'
import Renderif from 'utils/renderif'

const RewardView = () => {
  
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = location.state || {}
  const exchage = location.state?.exchage
 


  const [isSelectedCheckbox, setIsSelectedCheckbox] = useState(false)
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')

  const [showModal, setShowModal] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const [modalTitle, setModalTitle] = useState('')

  const [state, setState] = useState({
    generate:null
  })

  const handleCheckboxChange = (event) => {
    setIsSelectedCheckbox(event.target.checked)
  }

  const handleInputChange = (e) => {
    setEmail(e.target.value)
  }

  const onSendResult = async () => {
    

    try {

      const mail = await MailTaquilla({
        email:email,
        code:''
      })

      console.log(mail)
   
      if (mail?.data === true) {
        setModalMessage('¡Correo enviado exitosamente!')
        setModalTitle('Felicidades')
        setShowModal(true)
      } else if(mail?.data?.message === "Todas las recompensas ya fueron entregadas."){
        setModalMessage('!Todas las recompensas ya fueron entregadas¡')
        setModalTitle('Upps, lo sentimos...')
        setShowModal(true)
      } else{
        setModalMessage('¡No ha sido posible entregar tu recompensa, intenta de nuevo más tarde!')
        setModalTitle('Upps, lo sentimos...')
        setShowModal(true)
      }

    } catch (error) {
      console.error('Error posting result:', error)
    } finally {
      setLoading(false)
      const element = document.getElementById("sendcta");
      element.remove();
    }
    
  }

  const handleCloseModal = () => {
    setShowModal(false)
    navigate(`/${id}`)
  }

  useEffect(()=>{

    result()

    return () => {}
  },[])

  const generate = async () => {
      let _generate = await getGenerate()
      console.log(_generate.data.data)
      state.generate = _generate.data.data
      setState({...state})
  }

  const result = async () => {
    const body = {
      idActivity: id,
      status: '1',
      user: 'Yelmo',
    }
    const response = await postResult(body)
  }

  return (
    <>
      {loading && <Loading />}
      <div className="finish-container overflow-auto" style={styles.container}>
        <Header />
        <div className="square-container-reward " style={{marginTop:120}}>
            <div style={{width:'100%', maxWidth:400}}>
              <img width={'90%'} className='d-block mx-auto' style={{}} src='https://yelmo-paris.s3.eu-west-3.amazonaws.com/temp/51381bac-efcb-4542-845e-e39129dd2e1d.png'></img>
              <div className='d-block mx-auto px-3 text-center text-white bold pt-2' style={{width:'90%'}}>¡Enhorabuena! Has acertado todas las preguntas. Escribe tu correo para recibir dos (2) entradas al precio de una (1) en Cine Yelmo.</div>
            </div>

          {/* <Renderif isTrue={state.generate?.type === 'dulceria'}>
            <div style={{width:'100%', maxWidth:400}}>
              <img width={'90%'} className='d-block mx-auto' src='images/recompensa01.png'></img>
              <div className='d-block mx-auto px-3 text-center text-white bold pt-2' style={{width:'90%'}}>¡Enhorabuena! Has acertado todas las preguntas. Escribe tu correo para recibir un descuento en tu menú de palomitas a 6,90€.</div>
            </div>
          </Renderif>

          <Renderif isTrue={state.generate?.type === 'taquilla'}>
            <div style={{width:'100%', maxWidth:400}}>
              <img width={'90%'} className='d-block mx-auto' style={{}} src='images/recompensa02.png'></img>
              <div className='d-block mx-auto px-3 text-center text-white bold pt-2' style={{width:'90%'}}>¡Enhorabuena! Has acertado todas las preguntas. Escribe tu correo para recibir una entrada gratis para Cine Yelmo.</div>
            </div>
          </Renderif> */}

          {/* <SquareReward /> */}
        </div>
        <div className='' style={{width:370}}>
          <CheckboxWithText
            textOne={"YELMO  FILMS  S.L.U.  es  el  responsable  del  tratamiento  de  sus  datos  personales. Dicho tratamiento se realizará con la finalidad de entregar productos, descuentos y/o beneficios. La base legal del tratamiento de sus datos personales es la ejecución del  premio  obtenido y  su  consentimiento.  Puede  ejercer  sus  derechos  de protección de datos en datospersonales@yelmocines.es"}
            textTwo={'Más información en la Política de privacidad'}
            onChange={handleCheckboxChange}
            checked={isSelectedCheckbox}
          />
        </div>

        <div style={styles.containerText}>
          <h1 style={styles.email}>Escribe tu correo para recibir tu recompensa</h1>
        </div>
        <Form.Group className="mb-3">
          <Form.Control
            style={{ width: '300px', height: '50px' }}
            type="email"
            placeholder="Correo electrónico"
            aria-label="Correo electrónico"
            value={email}
            onChange={handleInputChange}
          />
        </Form.Group>
        {false && (
          <div style={styles.containerText}>
            <h1 style={styles.error}>Ups! Parece que ya obtuviste una recompensa</h1>
            <h1 style={styles.error}>por este juego.</h1>
          </div>
        )}
        {/* <CheckboxWithText
          textOne={'Al enviar mi correo electrónico, acepto la'}
          textTwo={'Política de Privacidad.'}
          onChange={handleCheckboxChange}
          checked={isSelectedCheckbox}
        /> */}
        <Button id="sendcta" style={styles.button} onClick={onSendResult} disabled={!isSelectedCheckbox} className="mb-3">
          <LuSend style={styles.iconSend} />
          Enviar
        </Button>
        <div className='my-5 py-5'></div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
      </Modal>
    </>
  )
}

const styles = {
  container: {
    display: 'flex',
  
    // justifyContent: 'center',
    // alignItems: 'center',
    height: '100vh',
    background: `linear-gradient(149.96deg, ${Colors.secondary} 30.95%, ${Colors.fourth} 106.92%)`,
  },
  containerText: {
    marginBottom: 5,
  },
  email: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontSize: '15px',
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
  },
  error: {
    color: Colors.primary,
    fontFamily: 'TTNormsRegular',
    fontSize: 'small',
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
  },
  button: {
    backgroundColor: Colors.yelmoPurple,
    borderColor: Colors.yelmoPurple,
    height: '45px',
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontSize: 'medium',
    width: '50%',
    marginLeft: '2%',
    marginTop: '2%',
    borderRadius: '10px',
  },
  iconSend: {
    fontSize: '16px',
    marginRight: '2%',
  },
}

export default RewardView
